var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',_vm._b({staticClass:"input_color",attrs:{"value":_vm.value,"required":_vm.required,"trim":""},on:{"input":_vm.updateValue}},'b-form-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }